export default "__VITE_ASSET__C3crs7An__"